// @dynamic-i18n-keys
// Dynamic t() at line 46 (gallectionType: GallectionType):
//   pages.gallections.addNew.var.gallery
//   pages.gallections.addNew.var.collection
//   pages.gallections.addNew.var.private_collection
//   pages.gallections.addNew.var.stash
import type { FC } from 'react';
import { useState } from 'react';
import classnames from 'classnames';
import {
  GallectionResourceType,
  GallectionType,
  gallectionTypeToResourceType,
} from '@wix/da-shared-react/pkg/types/gallection';
import AddItem from '@wix/da-ds/pkg/AddItem';
import MediaManager, {
  getMediaSourceFromGallectionType,
} from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import {
  type AddNewFolderClickBiEvent,
  BiContextProvidedValue,
  BiData,
} from '@wix/da-bi/pkg/events';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';

import s from './AddNewFolderCard.scss';

export type Props = {
  width: number;
  className?: string;
  gallectionType: GallectionType;
  owner: PapiUser;
};
export const AddNewFolderCard: FC<Props> = ({
  className,
  width,
  gallectionType,
  owner,
}) => {
  const { t } = useTranslation();
  const [isMediaManagerShown, setShowMediaManager] = useState(false);
  const closeMediaManagerAndReload = event => {
    setShowMediaManager(false);
    event && event.preventDefault();
    window.location.reload();
  };

  return (
    <>
      <div className={classnames(className, s['root'])} style={{ width }}>
        <AddItem
          className={s['card']}
          title={t(`pages.gallections.addNew.var.${gallectionType}`)}
          onClick={() => setShowMediaManager(true)}
          biData={BiData<AddNewFolderClickBiEvent>({
            evid: 40,
            typeid:
              gallectionTypeToResourceType(gallectionType) ??
              GallectionResourceType.GALLERY,
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
          })}
        />
      </div>
      {isMediaManagerShown && (
        <MediaManager
          initialMediaSource={getMediaSourceFromGallectionType(gallectionType)}
          withMediaSourceSelector={false}
          withNewGallectionPopupOpen
          gruser={owner}
          onDone={closeMediaManagerAndReload}
          onClose={closeMediaManagerAndReload}
        />
      )}
    </>
  );
};

AddNewFolderCard.displayName = 'AddNewFolderCard';
export default AddNewFolderCard;
